module.exports = __webpack_public_path__ + "portal/assets/img/logo.c06ac71e.svg";